import { type ReactElement } from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { PersonalKeyControl } from '@/pages/dashboard/components/PersonalKeyControl';
import { Section } from '../Section';

export function ApiKeysSection(): ReactElement {
  return (
    <Section
      title="API Keys"
      description="Manage your API key to authenticate Kirin scans and protect your development environment"
    >
      <Card>
        <CardHeader>
          <CardTitle>Personal API Key</CardTitle>
          <CardDescription>
            Authenticate Kirin scans and IDE extensions with a key tied to your
            account
          </CardDescription>
        </CardHeader>
        <CardContent>
          <PersonalKeyControl />
        </CardContent>
      </Card>
    </Section>
  );
}
